<jhi-custom-box [title]="'spans.verifyPin.boxtitle'"
                [requiredFields]="true"
                [boxSize]="'box-620'"
                [successMsg]="successMsg"
                (successEmitter)="redirect()"
                [successButtonLabel]="isFirstLogin ? 'buttons.returntoapp' : 'buttons.ok'"
                [errorMsg]="errorMsg"
                (failureEmitter)="redirectOnFailure()"
>

    <div class="row p-0 mb-3">
        <div class="col-12 text-center">
            <span jhiTranslate="spans.verifyPin.message"></span>
        </div>
    </div>

    <form [formGroup]="pinForm" *ngIf="objectFromEditAccountInfo">

        <div class="form-group">

            <div class="row m-t-5"  *ngIf="objectFromEditAccountInfo.phone && !objectFromEditAccountInfo.phoneVerified && phoneValidationEnabled">
                <div class="col-3 text-right mb-auto mt-auto">
                    <label class="mb-0" for="mobile-input" jhiTranslate="spans.verifyPin.formlabels.mobilePin"> Mobile pin </label>
                </div>
                <div class="col-9 d-flex">
                    <input maxlength="6" [readOnly]="submitted" [placeholder]="'spans.verifyPin.formplaceholders.mobilePin' | translate" id="mobile-input" [formControlName]="'mobilePin'" class="m-r-10 form-control m-t-15"
                           [ngClass]="errorCheck && f.mobilePin.errors ? 'is-invalid': ''" />
                    <button type='button' (click)="resendOtp(PinType.MOBILE)" class="btn secondary-btn no-margin-i ladda-button max-w-120" data-style="expand-right">
                        <span class="ladda-label" jhiTranslate="buttons.resendOtp"></span>
                    </button>
                </div>
            </div>

            <div class="row m-t-5"  *ngIf="objectFromEditAccountInfo.email && !objectFromEditAccountInfo.emailVerified">
                <div class="col-3 text-right mb-auto mt-auto">
                    <label class="mb-0" for="email-input" jhiTranslate="spans.verifyPin.formlabels.emailPin"> Email pin </label>
                </div>
                <div class="col-9 d-flex">
                    <input maxlength="6" [readOnly]="submitted" [placeholder]="'spans.verifyPin.formplaceholders.emailPin' | translate" id="email-input" [formControlName]="'emailPin'" class="m-r-10 form-control m-t-15"
                           [ngClass]="errorCheck && f.emailPin.errors ? 'is-invalid': ''" />
                    <button type='button' (click)="resendOtp(PinType.EMAIL)" class="btn secondary-btn no-margin-i ladda-button max-w-120" data-style="expand-right">
                        <span class="ladda-label" jhiTranslate="buttons.resendOtp"></span>
                    </button>
                </div>
            </div>

            <div class="row m-t-5" *ngIf="objectFromEditAccountInfo.alternativeEmail && !objectFromEditAccountInfo.alternativeEmailVerified">
                <div class="col-3 text-right mb-auto mt-auto">
                    <label class="mb-0" for="email-alt-input" jhiTranslate="spans.verifyPin.formlabels.emailAltPin"> EmailAlt pin </label>
                </div>
                <div class="col-9 d-flex">
                    <input maxlength="6" [readOnly]="submitted" [placeholder]="'spans.verifyPin.formplaceholders.emailAltPin' | translate" id="email-alt-input"
                           [formControlName]="'emailAltPin'" class="m-r-10 form-control m-t-15" [ngClass]="errorCheck && f.emailAltPin.errors ? 'is-invalid': ''" />
                    <button type='button' (click)="resendOtp(PinType.ALT_MAIL)" class="btn secondary-btn no-margin-i ladda-button max-w-150" data-style="expand-right">
                        <span class="ladda-label" jhiTranslate="buttons.resendOtp"></span>
                    </button>
                </div>
            </div>

        </div>

        <div class="row text-center d-flex">
            <div class="col-12 mx-auto">
                <span *ngIf="timeoutOTPActive" jhiTranslate="spans.verifyPin.pin.active"></span>
                <span *ngIf="timeoutOTPActive">{{ timeoutOTP * 1000 | date: 'mm:ss' }}</span>
                <span *ngIf="timeoutOTPActive" jhiTranslate="spans.verifyPin.pin.minutes"></span>
                <span *ngIf="!timeoutOTPActive" class="text-danger" jhiTranslate="spans.verifyPin.pin.inactive">Codici scaduti</span>
            </div>
        </div>

        <div class="row text-center d-flex">
            <div class="col-12">
                <button [disabled]="submitted" type="button" class="btn secondary-btn float-left" (click)="backToApp()" jhiTranslate="buttons.back">Return to application</button>
                <button [disabled]="submitted" (click)="onReset()" class="btn secondary-btn" jhiTranslate="buttons.discard">Discard</button>
                <button [ladda]="submitted" class="btn confirm-btn no-margin-i ladda-button max-w-150" data-style="expand-right">
                    <span class="ladda-label" jhiTranslate="buttons.submit" (click)="onSubmit()"></span>
                </button>
            </div>
        </div>
    </form>
</jhi-custom-box>
